import { useFormikContext } from "formik"
import { IBasketMeetingPlanningFormField } from "../../Types/MeetingPlanning/deliveryForm"
import React, { memo, useCallback } from "react"
import { TextArea } from "./TextField"
import { FormInputField } from "../../Modules/Forms/formTypes"

const MAX_LENGTH = 500

const TextareaControl = ({ field }: { field: FormInputField }) => {
    const { values, setFieldValue } = useFormikContext<IBasketMeetingPlanningFormField>()

    const setMessage = useCallback((value: string) => setFieldValue(field.name, value), [setFieldValue])

    return <TextArea
        id={field.name}
        name={field.name}
        minRows={1}
        maxRows={4}
        title={field.label as string}
        placeholder={field.placeholder}
        characterLimit={MAX_LENGTH}
        value={(values as Record<string, any>)[field.name]}
        onChange={(e) => setMessage(e.target.value)}
    />
}
export default memo(TextareaControl)
